import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchReviewerQueue,
  fetchReviewerSummary,
  type ReviewerQueueResponse,
  type ReviewerSummaryResponse,
} from '../../request/analytics/reviewerReports.ts';
import { analyticsReviewerQueryKeys } from '../../queries/analytics/keys.ts';
import { useAnalyticsScope } from './useAnalyticsScope.tsx';
import { scopeKey } from '../../request/analytics/scope.ts';

/**
 * React Query v5 hooks for the new Reviewer persona dashboard (6th persona,
 * dashboard_key 'reviewer', feedback round 2026-08). Read-only, same pattern
 * as the External Auditor hooks.
 */

export function useReviewerQueue(): UseQueryResult<ReviewerQueueResponse, Error> {
  const scope = useAnalyticsScope();
  return useQuery({ queryKey: analyticsReviewerQueryKeys.queue(scopeKey(scope)), queryFn: () => fetchReviewerQueue(scope) });
}

export function useReviewerSummary(): UseQueryResult<ReviewerSummaryResponse, Error> {
  const scope = useAnalyticsScope();
  return useQuery({ queryKey: analyticsReviewerQueryKeys.summary(scopeKey(scope)), queryFn: () => fetchReviewerSummary(scope) });
}
